module.exports = __webpack_public_path__ + "img/mobile_platform.59681d58.svg";